import axios from '../axios';

export const getVehicleBids = async (vehicleId) => {
	const bids = await axios.get(`/api/bids/${vehicleId}`);
	return bids;
};

export const createBid = (params, signal) => axios.post('/api/bids', params, { signal });

export const generatePurchasesCsv = (params) => axios.post('/api/generate_purchases_csv', params);

export const getPurchasesCsv = () => axios.get('/api/get_purchases_csv', { contentType: 'text/csv' });

export default {
	createBid,
	getVehicleBids,
};
